var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgList = function SvgList(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9343FA9A-68FA-4230-B99C-32F31FDCB164") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-174.000000, -948.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-list",
    transform: "translate(174.000000, 948.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,16.5 C4.32842712,16.5 5,17.1715729 5,18 L5,18 L5,20 C5,20.8284271 4.32842712,21.5 3.5,21.5 L3.5,21.5 L1.5,21.5 C0.671572875,21.5 0,20.8284271 0,20 L0,20 L0,18 C0,17.1715729 0.671572875,16.5 1.5,16.5 L1.5,16.5 Z M23,18 C23.5522847,18 24,18.4477153 24,19 C24,19.5522847 23.5522847,20 23,20 L23,20 L8.5,20 C7.94771525,20 7.5,19.5522847 7.5,19 C7.5,18.4477153 7.94771525,18 8.5,18 L8.5,18 Z M3.5,8.5 C4.32842712,8.5 5,9.17157288 5,10 L5,10 L5,12 C5,12.8284271 4.32842712,13.5 3.5,13.5 L3.5,13.5 L1.5,13.5 C0.671572875,13.5 0,12.8284271 0,12 L0,12 L0,10 C0,9.17157288 0.671572875,8.5 1.5,8.5 L1.5,8.5 Z M23,10 C23.5522847,10 24,10.4477153 24,11 C24,11.5522847 23.5522847,12 23,12 L23,12 L8.5,12 C7.94771525,12 7.5,11.5522847 7.5,11 C7.5,10.4477153 7.94771525,10 8.5,10 L8.5,10 Z M3.5,0.5 C4.32842712,0.5 5,1.17157288 5,2 L5,2 L5,4 C5,4.82842712 4.32842712,5.5 3.5,5.5 L3.5,5.5 L1.5,5.5 C0.671572875,5.5 0,4.82842712 0,4 L0,4 L0,2 C0,1.17157288 0.671572875,0.5 1.5,0.5 L1.5,0.5 Z M23,2 C23.5522847,2 24,2.44771525 24,3 C24,3.55228475 23.5522847,4 23,4 L23,4 L8.5,4 C7.94771525,4 7.5,3.55228475 7.5,3 C7.5,2.44771525 7.94771525,2 8.5,2 L8.5,2 Z",
    id: "Combined-Shape"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list.d1ba63d88d1b52d024e2ed6cd12dd85f.svg";